import {Component} from '@angular/core';

@Component({
    selector: 'ui-lens-beacon',
    template: '',
    styleUrls: ['beacon.component.scss']
})
export class UILensBeaconComponent {
}